import {
    GA_CHANGE_PAGE_ACTION,
    GA_SEARCH_CATEGORY,
} from '../../../../../constants/analytics';
import { updateSearchCriteria } from '../../../../../redux/actions/search';
import { DiscoverState } from '../../../../../types';

export const handleGetPage =
    (futurePage: number) => (dispatch: Function, getState: Function) => {
        const state: DiscoverState = getState();
        const {
            search: { eventSearch },
        } = state;

        const newEventSearch = {
            ...eventSearch,
            page: futurePage,
        };

        const gaTrackingData = {
            category: GA_SEARCH_CATEGORY,
            label: `${eventSearch.page}-${futurePage}`,
            action: GA_CHANGE_PAGE_ACTION,
        };

        dispatch(updateSearchCriteria(newEventSearch, [gaTrackingData]));
    };
